<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="512"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="red" append-icon="mdi-delete-outline" v-bind="props">
        Excluir
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline"> Confirmação de Remoção </v-card-title>

      <v-card-text>
        Você tem certeza que deseja remover este Fluxo?
      </v-card-text>

      <v-card-actions>
        <v-btn color="red darken-1" dark @click="submitForm">Sim</v-btn>
        <v-btn color="blue darken-1" dark @click="dialog = false">Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  emits: ['fluxoRemovido'],
  data: () => ({
    dialog: false,
  }),
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    async submitForm() {
      try {
        const response = await axios.delete(
          // eslint-disable-next-line max-len
          `${apiUrl}/api/v1/fluxoCasoUso/${this.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );

        const idCsu = this.$route.params.id;
        const idProjeto = this.$route.params.idProjeto;

        this.$toast.success(response.data.msg);
        this.$emit('fluxoRemovido', idCsu);
        this.$router.push(`/projects/${idProjeto}/CasoUso/${idCsu}`);
      } catch (error) {
        console.log(error);
        this.$toast.error(error.response.data.msg);
      } finally {
        this.dialog = false;
      }
    },
  },
};
</script>
